const bulkUploadActions = {
    UPLOAD_BULK_CANDIDATE_DATA: 'UPLOAD_BULK_CANDIDATE_DATA',
   
};

export default bulkUploadActions;